<template>
  <div class="p-2">
    <loader v-show="isLoading" :active="isLoading" class="sticky sticky-loader" />

    <el-form v-if="!isLoading" :model="helpy" :rules="rules" label-position="top" ref="helpyForm" label-width="120px">
      <div class="clearfix pb-2 pt-2">
        <div class="float-end">
          <div class="d-none d-md-flex gap-1">
            <el-form-item>
              <el-button data-id="helpy-save" type="primary" @click="onSave">{{
                $i18n.t('dynform_button_save')
              }}</el-button>
              <el-button data-id="helpy-close" @click="onClose">{{ $i18n.t('dynform_button_close') }}</el-button>
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="d-flex gap-3">
        <el-form-item :label="$i18n.t('Category')" prop="category" class="col-3">
          <el-select data-id="helpy-category" v-model="helpy.category" :disabled="hasCategory" class="w-100">
            <el-option
              v-for="category in categories"
              :key="category.key"
              :label="category.label"
              :value="category.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$i18n.t('Language')" prop="language" class="col-3">
          <el-select data-id="helpy-language" v-model="helpy.language" class="w-100">
            <el-option
              v-for="language in languages"
              :key="language.key"
              :label="language.label"
              :value="language.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$i18n.t('Title')" prop="title" class="col-3">
          <el-input data-id="helpy-title" v-model="helpy.title" class="w-100"></el-input>
        </el-form-item>

        <el-form-item :label="$i18n.t('Subsystem')" prop="subsystem" class="col-2">
          <el-select data-id="helpy-subsystem" multiple v-model="helpy.visibleInSystems" class="w-100">
            <el-option
              v-for="subsystem in availableSystems"
              :key="subsystem.id"
              :label="subsystem.title"
              :value="subsystem.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class="d-flex gap-3">
        <el-form-item :label="$i18n.t('Type')" prop="type" class="col-2">
          <el-select data-id="helpy-type" v-model="helpy.type" class="w-100">
            <el-option v-for="type in types" :key="type.name" :label="type.name" :value="type.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$i18n.t('Url')" prop="url" class="col-4">
          <div class="el-input w-100">
            <tag-input data-id="helpy-url" v-model="helpy.url"></tag-input>
          </div>
        </el-form-item>

        <el-form-item :label="$i18n.t('Order')" prop="order" class="col-2">
          <el-input data-id="helpy-order" v-model="helpy.order" type="number" class="w-100"></el-input>
        </el-form-item>

        <el-form-item v-if="hasSelector" :label="$i18n.t('Selector')" prop="selector" class="col-3">
          <el-input data-id="helpy-selector" v-model="helpy.selector" class="w-100"></el-input>
        </el-form-item>
      </div>

      <el-form-item :label="$i18n.t('Content')" prop="content">
        <froala-editor data-id="helpy-content" v-model="helpy.content" :text="helpy.content"></froala-editor>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from 'qs'
import Loader from '../Loader'
import { isEmpty, isArray, get } from 'lodash'
import FroalaEditor from '../FroalaEditor'
import { helpyTypes } from './helpyTypes'
import notify from '../../utils/mixin-notify'
import EventBus from '../../utils/event-bus'
import formStore from '../../store/modules/form/index'
import TagInput from '../helpy/TagInput'

export default {
  name: 'HelpyForm',
  mixins: [notify],
  components: {
    TagInput,
    FroalaEditor,
    Loader,
  },
  instanceStore: {
    name: 'formStore',
    module: formStore,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    const validateSelector = (rule, value, callback) => {
      if (this.hasSelector && !value) {
        callback(new Error(this.$i18n.t('please_enter_selector')))
      } else {
        callback()
      }
    }
    return {
      helpy: {
        id: null,
        type: null,
        url: [],
        title: '',
        content: '',
        order: 0,
        selector: '',
        category: '',
        language: '',
        visibleInSystems: [],
      },
      rules: {
        category: [
          {
            required: true,
            message: this.$i18n.t('please_select_category'),
            trigger: 'blur',
          },
        ],
        language: [
          {
            required: true,
            message: this.$i18n.t('please_select_language'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: this.$i18n.t('please_enter_title'),
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: this.$i18n.t('please_select_type'),
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: this.$i18n.t('please_enter_content'),
            trigger: 'blur',
          },
        ],
        selector: [{ validator: validateSelector, trigger: 'blur' }],
      },
      languages: [],
      categories: [],
      availableSystems: [],
      types: helpyTypes || [],
      isLoading: true,
      hasCategory: true,
    }
  },
  computed: {
    hasSelector() {
      return [2, 3].includes(this.helpy.type)
    },
    dirty() {
      return this.$get('dirty')
    },
  },
  methods: {
    getHelpy(id) {
      return this.$client
        .execute({
          operationId: 'Helpy_findOne',
          method: 'get',
          parameters: {
            filter: JSON.stringify({
              where: { id },
            }),
          },
        })
        .catch((e) => console.error(e))
    },
    getLanguages() {
      return this.$CORE.IntlLanguages
    },
    getCategories() {
      return this.$client
        .execute({
          operationId: 'HelpyCategory_getCategoriesWithoutTree',
          method: 'get',
        })
        .catch((e) => console.error(e))
    },
    getSubsystems() {
      return this.$client
        .execute({
          operationId: 'Dynform_getSubsystemList',
          method: 'get',
        })
        .catch((e) => console.error(e))
    },
    async fetchData() {
      this.helpy.id = this.getUrlParam() || null

      if (!this.helpy.id) {
        const selectedCategory = localStorage.getItem('helpy-designer--category')
        this.helpy.category = selectedCategory || null
        this.hasCategory = !!this.helpy.category
        this.isLoading = false
        return
      }

      const data = await this.getHelpy(this.helpy.id)

      if (!data || isEmpty(data.body)) return

      this.helpy.id = data.body.id || null
      this.helpy.url = this.getUrlValue(data.body.url)
      this.helpy.title = data.body.title
      this.helpy.type = data.body.type
      this.helpy.order = data.body.order
      this.helpy.selector = data.body.selector
      this.helpy.content = data.body.content
      this.helpy.language = data.body.language
      this.helpy.category = data.body.category
      this.helpy.visibleInSystems = data.body.visibleInSystems

      this.isLoading = false
    },
    getUrlValue(url) {
      if (!isArray(url) && !!url === false) return null
      return isArray(url) ? url : [url]
    },
    getUrlParam() {
      if (this.url) {
        const queryString = get(this.url.split('?'), '[1]', '')
        const queryParams = qs.parse(queryString)
        return queryParams.mongoId
      } else if (this.$route.query) {
        return this.$route.query.mongoId
      }
      return null
    },
    async onSave() {
      this.$refs['helpyForm'].validate((isValid) => {
        if (isValid) {
          this.saveData().then((response) => {
            this.helpy.id = response.body.id
            if (!this.helpy.id) {
              this.showNotification({
                group: 'basic-notification',
                title: 'helpy_save_error',
                type: 'error',
              })
              return
            }
            this.$emit('form-saved')
            EventBus.$emit('refresh-helpy-list')
            EventBus.$emit('refresh-helpy-tree')
            this.showNotification({
              group: 'basic-notification',
              title: 'helpy_save_success',
              type: 'success',
            })
          })
        } else {
          return
        }
      })
    },
    onClose() {
      this.$emit('form-close')
      EventBus.$emit('refresh-helpy-list')
    },
    saveData() {
      return this.$client
        .execute({
          operationId: 'Helpy_save',
          method: 'post',
          parameters: {
            data: {
              id: this.helpy.id,
              url: this.helpy.url,
              type: this.helpy.type,
              title: this.helpy.title,
              order: this.helpy.order,
              content: this.helpy.content,
              language: this.helpy.language,
              category: this.helpy.category,
              selector: this.helpy.selector,
              visibleInSystems: this.helpy.visibleInSystems,
            },
          },
          requestContentType: 'application/x-www-form-urlencoded',
        })
        .catch((e) => {
          console.log(e)
          this.showNotification({
            group: 'basic-notification',
            title: 'helpy_save_error',
            type: 'danger',
          })
        })
    },
  },
  async mounted() {
    const categories = await this.getCategories()
    this.categories = categories.body.map((c, index) => {
      return { key: index, value: c.id, label: c.title }
    })
    const languages = await this.getLanguages()
    this.languages = languages.map((l, index) => {
      return { key: index, value: l.idIntlLanguage, label: l.code }
    })
    const subsystems = await this.getSubsystems()
    this.availableSystems = subsystems.obj.map((s) => {
      return { title: s.text, id: s.value }
    })

    'input click'.split(' ').forEach((event) => {
      this.$el.addEventListener(event, (e) => {
        if (e.type === 'input' || (e.type === 'click' && ['checkbox', 'radio'].includes(get(e, 'target.type')))) {
          this.$commit('FORM_SET_DIRTY', { isDirty: true })
        }
      })
    })
  },
  async created() {
    await this.fetchData()
  },
  destroyed() {
    this.$store.unregisterModule([this.$storeNamespace])
  },
  watch: {
    dirty(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('dirty-change', newValue)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 208px;
}
.helpy-save {
  margin-top: 20px;
}
.sticky {
  align-items: flex-end !important;
}
.sticky-top {
  top: 75px;
  background: transparent;
}
</style>
